const dangerRatColonyPlayerSpritesheet = {
  "name": "dangerRatColonyPlayerSpritesheet",
  "tileHeight": 128,
  "tileWidth": 128,
  "spacing": 0,
  "tileCount": 2,
  "columns": 2,
  "animationSpeed": 0.1,
  "spritesheet": "./assets/spritesheets/dangerRatPlayerSpritesheet.png",
  "sprites": {
    "dangerRatColonyPlayerHead": [0],
    "dangerRatColonyPlayerBody": [0]
  }
}
export default dangerRatColonyPlayerSpritesheet;
